module.exports = __webpack_public_path__ + "img/minus.1cbe3eb3.svg";